export default __webpack_public_path__ + "static/eSignPicture-6e27cc88a2c0e4b8cdcb0e25a7fe312a.png";